
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, IdCard, Image as ImageIcon, FileText } from "lucide-react";
import { EmployeeFiles } from "@/types/employee";

interface FileUploadSectionProps {
  files: EmployeeFiles;
  onFileChange: (type: keyof EmployeeFiles, file: File | null) => void;
}

export const FileUploadSection = ({ files, onFileChange }: FileUploadSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-slate-800 border-b pb-2">ملفات الرفع</h3>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="certificate">الشهادة</Label>
          <div className="flex items-center gap-2">
            <Input
              id="certificate"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              onChange={(e) => onFileChange('certificate', e.target.files?.[0] || null)}
            />
            <GraduationCap className="w-5 h-5 text-blue-600" />
          </div>
          {files.certificate && (
            <p className="text-sm text-green-600">تم اختيار: {files.certificate.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="national_id">الهوية الوطنية</Label>
          <div className="flex items-center gap-2">
            <Input
              id="national_id"
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => onFileChange('national_id', e.target.files?.[0] || null)}
            />
            <IdCard className="w-5 h-5 text-green-600" />
          </div>
          {files.national_id && (
            <p className="text-sm text-green-600">تم اختيار: {files.national_id.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="profile_image">الصورة الشخصية</Label>
          <div className="flex items-center gap-2">
            <Input
              id="profile_image"
              type="file"
              accept=".jpg,.jpeg,.png,.gif"
              onChange={(e) => onFileChange('profile_image', e.target.files?.[0] || null)}
            />
            <ImageIcon className="w-5 h-5 text-purple-600" />
          </div>
          {files.profile_image && (
            <p className="text-sm text-green-600">تم اختيار: {files.profile_image.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="contract">نسخة من العقد</Label>
          <div className="flex items-center gap-2">
            <Input
              id="contract"
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={(e) => onFileChange('contract', e.target.files?.[0] || null)}
            />
            <FileText className="w-5 h-5 text-amber-600" />
          </div>
          {files.contract && (
            <p className="text-sm text-green-600">تم اختيار: {files.contract.name}</p>
          )}
        </div>
      </div>
    </div>
  );
};
